import type { ApiResponseStatus } from '../domain/api';


// Take api axios response as param and check status, if ok return else throw error (dont set the data here)
export const handleHttpError = (apiResponseStatus : ApiResponseStatus) => {
    if (apiResponseStatus.code !== null && apiResponseStatus.code) {
        
        if (apiResponseStatus.code >= 200 && apiResponseStatus.code <= 299) {
            apiResponseStatus.text = 'success';
            return;
        }
        throw new Error(apiResponseStatus.text);
        
    }
    throw new Error('Unrecognized Error');
};